/** Direct row in a settings section. Whitespace, rather than rules, separates peers. */
export const ITEM_ROW_CLASSNAME = "rounded-xl px-3 py-3 sm:px-4";

export const ITEM_ROW_INNER_CLASSNAME =
  "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between";
